import { colorPalette } from '../../colorPalette';
export const ClubPopinStyle = {
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        padding: '24px 16px',
        backgroundColor: colorPalette.white,
        width: '516px',
        borderRadius: '8px',
        boxShadow: `1px 4px 10px 2px ${colorPalette.gray700}`,
    },
    closeButton: {
        width: '24px',
        height: '24px',
        cursor: 'pointer',
    },
    label: {
        backgroundColor: colorPalette.red100,
        margin: '24px',
        padding: '4px 8px',
        color: colorPalette.red800,
        borderRadius: '4px',
        letterSpacing: '0.2px',
    },
    campaignContainer: {
        boxSizing: 'border-box',
        borderRadius: '8px',
        backgroundColor: colorPalette.red100,
        padding: '16px',
        marginBottom: '16px',
    },
    campaignIconBox: {
        width: '28px',
        height: '28px',
        overflow: 'hidden',
        margin: '8px 16px 8px 8px',
    },
    cashbackContainer: {
        border: `1px solid ${colorPalette.gray300}`,
        padding: '16px 0',
        width: '337px',
        borderRadius: '8px',
        paddingLeft: '36px',
        flexWrap: 'wrap',
    },
};
